export const SET_POSTINGS = 'SET_POSTINGS';
export const SET_MATCH = 'SET_MATCH';
export const SET_POSTING_UNSUBSCRIBE_FN = 'SET_POSTING_UNSUBSCRIBE_FN';
export const SET_ACTIVE_POSTING = 'SET_ACTIVE_POSTING';
export const SET_VIEW_MODE = 'SET_VIEW_MODE';
